import { useEffect, useState } from 'react';
import { fetchApplicationSettingsAsync } from '../services/configuration/config';

let cachedSettings: {
  isCloud: boolean | null;
  enablePumpChecker: boolean | null;
  hostingEnvironment: boolean | null;
  enableLicenseCheck: boolean | null;
} | null = null;

const useConfig = () => {
  const [isCloud, setIsCloud] = useState<boolean | null>(null);
  const [enablePumpChecker, setEnablePumpChecker] = useState<boolean | null>(null);
  const [hostingEnvironment, setHostingEnvironment] = useState<boolean | null>(null);
  const [enableLicenseCheck, setEnableLicenseCheck] = useState<boolean | null>(null);

  useEffect(() => {
    const getSettings = async () => {
      //TODO : Need to remove disablePumpChecker after the feature is verified
      const disablePumpChecker = !(localStorage.getItem('disablePumpChecker') == 'true');
      if (cachedSettings) {
        setIsCloud(cachedSettings.isCloud);
        setEnablePumpChecker(cachedSettings.enablePumpChecker && disablePumpChecker);
        setHostingEnvironment(cachedSettings.hostingEnvironment);
        setEnableLicenseCheck(cachedSettings.enableLicenseCheck);
      } else {
        const settings = await fetchApplicationSettingsAsync();
        if (settings) {
          const newSettings = {
            isCloud: settings.values.ApplicationDeploymentMode?.toLowerCase() !== 'onprem',
            enablePumpChecker: settings.values.EnablePumpChecker?.toLowerCase() === 'true' && disablePumpChecker,
            hostingEnvironment: settings.values.HostingEnvironment?.toLowerCase() !== 'localad',
            enableLicenseCheck: settings.values.EnableLicenseCheck?.toLowerCase() === 'true',
          };

          cachedSettings = newSettings;

          setIsCloud(newSettings.isCloud);
          setEnablePumpChecker(newSettings.enablePumpChecker && disablePumpChecker);
          setHostingEnvironment(newSettings.hostingEnvironment);
          setEnableLicenseCheck(newSettings.enableLicenseCheck);
        }
      }
    };

    getSettings();
  }, []);

  return { isCloud, enablePumpChecker, hostingEnvironment, enableLicenseCheck};
};

export default useConfig;
